import reduceReducers from "reduce-reducers";

import { SCAN_LABEL } from "constants/actionTypes";

import {
  offlineCrudReducer,
  resetStateOnRoleChangeReducer,
} from "lib/reducers";
import { deserializeScanLabel as deserializer } from "lib/serializers/scanLabel";

const scanLabelCrudReducer = offlineCrudReducer(SCAN_LABEL, {
  deserializer,
});

const scanLabelReducer = reduceReducers(
  scanLabelCrudReducer,
  resetStateOnRoleChangeReducer,
);

export default scanLabelReducer;
